webpackJsonp([89],{

/***/ 2384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCardTesting_vue__ = __webpack_require__(3487);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffe131a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCardTesting_vue__ = __webpack_require__(4106);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4104)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCardTesting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffe131a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCardTesting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/testing/BaseCardTesting.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ffe131a2", Component.options)
  } else {
    hotAPI.reload("data-v-ffe131a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'base-card': function baseCard() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 277));
    },
    'labeled-text': function labeledText() {
      return __webpack_require__.e/* import() */(150).then(__webpack_require__.bind(null, 2752));
    },
    'clinic-history': function clinicHistory() {
      return __webpack_require__.e/* import() */(141).then(__webpack_require__.bind(null, 2754));
    }
  },
  data: function data() {
    return {
      hidden: false,
      currentClassColor: 'medium'
    };
  },

  methods: {
    updateColors: function updateColors(e) {
      if (e.target.classList.contains('hidden-thumb')) {
        return;
      }
      var color = e.target.id.toString().indexOf('stress') > -1 ? e.target.value < 4 ? 'high' : e.target.value < 8 ? 'medium' : 'low' : e.target.value < 4 ? 'low' : e.target.value < 8 ? 'medium' : 'high';
      // Apply class to event element
      e.target.classList.remove(this.currentClassColor);
      this.currentClassColor = color;
      e.target.classList.add(color);
    }
  }
});

/***/ }),

/***/ 4104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4105);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b552eabc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ffe131a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseCardTesting.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ffe131a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseCardTesting.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4105:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.container {\n  padding-top: 10rem;\n  padding-bottom: 10rem;\n}\n.range-slider {\n  position: relative;\n  width: 100%;\n}\n.range-slider .ticks div {\n  display: inline-block;\n  position: absolute;\n}\n.range-slider .ticks div:first-child {\n  left: 0;\n}\n.range-slider .ticks div:last-child {\n  right: 0;\n}\n/*Chrome*/\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\ninput[type='range'] {\n    width: 100%;\n    overflow: hidden;\n    background-color: #E4E4E4;\n    -webkit-appearance: none;\n    border-radius: 15px;\n    /* .health-colors-shadow(-moz-range-thumb, ~'::'); */\n}\ninput[type='range'].high::-webkit-slider-thumb {\n    -webkit-box-shadow: -100px 0 0 100px #95B665;\n            box-shadow: -100px 0 0 100px #95B665;\n}\ninput[type='range'].medium::-webkit-slider-thumb {\n    -webkit-box-shadow: -100px 0 0 100px #fcdf4a;\n            box-shadow: -100px 0 0 100px #fcdf4a;\n}\ninput[type='range'].low::-webkit-slider-thumb {\n    -webkit-box-shadow: -100px 0 0 100px #B1324E;\n            box-shadow: -100px 0 0 100px #B1324E;\n}\ninput[type='range'].high::-webkit-slider-runnable-track {\n    -webkit-box-shadow: -100px 0 0 100px #95B665;\n            box-shadow: -100px 0 0 100px #95B665;\n}\ninput[type='range'].medium::-webkit-slider-runnable-track {\n    -webkit-box-shadow: -100px 0 0 100px #fcdf4a;\n            box-shadow: -100px 0 0 100px #fcdf4a;\n}\ninput[type='range'].low::-webkit-slider-runnable-track {\n    -webkit-box-shadow: -100px 0 0 100px #B1324E;\n            box-shadow: -100px 0 0 100px #B1324E;\n}\ninput[type='range'].high::-moz-range-progress {\n    background-color: #95B665;\n    color: #95B665;\n}\ninput[type='range'].medium::-moz-range-progress {\n    background-color: #fcdf4a;\n    color: #fcdf4a;\n}\ninput[type='range'].low::-moz-range-progress {\n    background-color: #B1324E;\n    color: #B1324E;\n}\ninput[type='range'].high::-moz-range-track {\n    background-color: #95B665;\n    color: #95B665;\n}\ninput[type='range'].medium::-moz-range-track {\n    background-color: #fcdf4a;\n    color: #fcdf4a;\n}\ninput[type='range'].low::-moz-range-track {\n    background-color: #B1324E;\n    color: #B1324E;\n}\ninput[type='range'].high::-ms-fill-lower {\n    background-color: #95B665;\n    color: #95B665;\n}\ninput[type='range'].medium::-ms-fill-lower {\n    background-color: #fcdf4a;\n    color: #fcdf4a;\n}\ninput[type='range'].low::-ms-fill-lower {\n    background-color: #B1324E;\n    color: #B1324E;\n}\ninput[type='range'].high::-ms-fill-upper {\n    background-color: #95B665;\n    color: #95B665;\n}\ninput[type='range'].medium::-ms-fill-upper {\n    background-color: #fcdf4a;\n    color: #fcdf4a;\n}\ninput[type='range'].low::-ms-fill-upper {\n    background-color: #B1324E;\n    color: #B1324E;\n}\ninput[type='range'] {\n    border-radius: 15px;\n    -webkit-appearance: none;\n}\ninput[type='range']::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    height: 12px;\n    width: 12px;\n    border-radius: 30px;\n    cursor: pointer;\n    /* border: 20px solid #2A5172 !important; */\n    /* border-top-left-radius: 30px;\n      border-bottom-left-radius: 30px; */\n    /*       width: 10px;\n      height: 10px;\n      cursor: ew-resize; */\n    background: #2A5172;\n}\ninput[type='range'].hidden-thumb.high::-webkit-slider-thumb {\n    background-color: #95B665;\n    color: #95B665;\n}\ninput[type='range'].hidden-thumb.medium::-webkit-slider-thumb {\n    background-color: #fcdf4a;\n    color: #fcdf4a;\n}\ninput[type='range'].hidden-thumb.low::-webkit-slider-thumb {\n    background-color: #B1324E;\n    color: #B1324E;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 4106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "range-slider" }, [
      _c("input", {
        staticClass: "health-slider medium hidden-thumb",
        attrs: {
          type: "range",
          value: "5",
          disabled: _vm.hidden,
          list: "tickmarks"
        },
        on: { change: _vm.updateColors }
      }),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ticks" }, [
      _c("div", [_vm._v("Muy mal")]),
      _vm._v(" "),
      _c("div", [_vm._v("Muy bien")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffe131a2", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/89.7830c033978d50e392d9.js